<template>
	<div class="tender-form" :class="{'tender-form--disabled': !canEdit}">
		<div class="form">
			<div class="form__inputs form__inputs--3">
				<InputSelect :label="'Выберите вариант повтора'" :errors="v$.repeatValue.$errors" >
					<template #select>
						<Multiselect
							:can-clear="false"
							:canDeselect="false"
							:options="[{id: 'weekNumber', name: 'Повторять по неделям'}, {id: 'monthNumber', name: 'Повторять по месяцам'}]"
							:placeholder="'Выберите как повторять тендер'"
							:label="'name'"
							:value-prop="'id'"
							v-model="repeatValue"
							:disabled="!canEdit"
							/>
					</template>
				</InputSelect>
				<ScheduleRepeatDates ref="repeatDates" v-if="repeatValue" :data="{repeatValue: repeatValue}" v-model="formData.dates" />
			</div>
		</div>
		<hr>
		<div class="tender-checkbox">
			<InputCheckbox label="Продлевать запрос" id="cx-add-time" v-model="formData.addTime" :disabled="!canEdit"/>
			<div class="tooltip">
				<span class="tooltip__icon"></span>
				<span class="tooltip__text">Если опция выбрана, то начиная с 5 минут до даты окончания тендера, с периодичностью в минуту выполняется проверка на новые предложения от поставщиков. Если предложения не были получены, то тендер переводится в статус "Подведение итогов".</span>
			</div>
		</div>
		<hr>
		<TenderTable ref="positions" v-model="formData.positions" :itsCO="this.type === 'CO'"/>
		<hr>
		<div class="detail-info">
			<div class="page-subtitle">Детальная информация о закупке</div>
			<InputTextarea v-model="formData.description" :readonly="!canEdit"/>
		</div>
		<UploadDocs v-if="canEdit" v-model="formData.documents"  :docsList="this.tender?.documents" dark/>
		<hr>
		<div class="page-content__btns">
			<div class="page-content__btns-right">
				<button v-if="['administrator'].includes(getUserRole)" class="btn btn--border" @click="sendForm">Сохранить</button>
			</div>
		</div>
		<PageLoader v-if="isLoading"/>
	</div>
</template>

<script>
import {mapActions} from "vuex";
import PageLoader from "@/components/base/utils/PageLoader.vue";
import InputTextarea from "@/components/base/utils/formElements/InputTextarea.vue";
import InputCheckbox from "@/components/base/utils/formElements/InputCheckbox.vue";
import InputSelect from "@/components/base/utils/formElements/InputSelect.vue";
import Multiselect from "@vueform/multiselect/src/Multiselect";
import TenderTable from "@/components/sections/Tenders/CreateEditTender/TenderTable.vue";
import UploadDocs from "@/components/base/utils/UploadDocs.vue";
import { useToast } from "vue-toastification";
import useVuelidate from "@vuelidate/core";
import moment from 'moment';
import ScheduleRepeatDates from "@/components/sections/Schedules/CreateEditSchedule/ScheduleRepeatDates.vue";
import objectToFormData from "@/utils/ObjectToFormData";
import Fetch from "@/utils/Fetch";
import {helpers, required} from '@vuelidate/validators'
import { mapGetters } from "vuex";
const {withMessage} = helpers

export default {
	name: "TenderForm",
	emits: ['changeType'],
	components: {
		ScheduleRepeatDates,
		InputSelect,
		InputCheckbox,
		Multiselect,
		TenderTable,
		UploadDocs,
		InputTextarea,
		PageLoader
	},
	props: {
		type : {
			type: String,
			default: 'TN'
		},
		deliveries: {
			type: Array,
			default: () => []
		},
		shopGroups: {
			type: Array,
			default: () => []
		},
		deliveryDestinations: {
			type: Array,
			default: () => []
		},
		productGroups: {
			type: Array,
			default: () => []
		},
		distrCenter: {
			type: Array,
			default: () => []
		},
	},
	setup() {
		return {
			v$: useVuelidate()
		}
	},
	data() {
		return {
			toast: useToast(),
			moment: moment,
			isLoading: false,
			tender: null,
			canEdit: false,
			formData: {
				name: '',
				auctionStart: '',
				auctionEnd: '',
				priceStep: '1',
				deliveries: [],
				deliveryDestinations: [],
				distrCenter: [],
				shopGroups: [],
				positions: [],
				documents: [],
				description: '',
				addTime: false,
				days: [],
			},
			auctionDates: [],
			auctionDatesKey: 0,
			tenderId: null,
			ShowApproveTenderPopup: false,
			repeatValue: ''
		}
	},
	async mounted() {
		const params = (new URL(document.location)).searchParams;
		const id = params.get("ID");
		if(id) {
			await this.loadTenderInfo(id);
		} else {
			this.fillDateAuction()
		}

		if(this.checkUserRole('administrator')) {
			this.canEdit = true
		}
	},

	computed: {
		deliveryDest() {
			if(this.formData.deliveries.length > 1) {
				const deliveryWithMostDestinations = this.deliveries.reduce((acc, curr) => {
						if (curr.deliveryDestinations.length > acc.deliveryDestinations.length) {
							return curr;
						} else {
							return acc;
						}
					}, this.deliveries[0]);
				return deliveryWithMostDestinations.deliveryDestinations
			}
			return this.deliveries.find(option => option.id === this.formData.deliveries[0])?.deliveryDestinations
		},
		getGroupOrCenter() {
			return (arg) => {
				if(this.formData.deliveryDestinations.length >= 2) return true
				return this.deliveryDestinations.find(option => option.id === this.formData.deliveryDestinations[0])?.[arg]
			}
		},
		...mapGetters({
			checkUserRole: 'user/checkUserRole',
			getUserRole: 'user/getUserRole',
		})
	},
    watch: {
		'formData.deliveries'() {
			this.formData.deliveryDestinations = []
			this.formData.distrCenter = []
			this.formData.shopGroups = []
		},
		'formData.deliveryDestinations'() {
			this.formData.distrCenter = []
			this.formData.shopGroups = []
		},

	},
	methods: {
		onDeletePeriod(key) {
			this.auctionDates = this.auctionDates.filter(item => item.key !== key);
		},
		onUpdateDates(dates, key) {
			const currentDates = this.auctionDates.find(dates => dates.key === key);
			if (currentDates) {
				Object.assign(currentDates, dates);
			}
		},
		addAuctionDates() {
			this.auctionDates.push({
				auctionStart: [''],
				auctionEnd: [''],
				key: this.auctionDatesKey++,
			})
		},
		getLocaleDateAndTime(value,needTime = true) {
			if (!value) return null
			const date = new Date(value).toLocaleDateString();
			const time = needTime ? new Date(value).toLocaleTimeString().slice(0,5) : '';
			if(time) {
				return `${date} ${time}`
			}
			return date
		},

		async sendForm() {
			this.isLoading = true
			const validated = await this.v$.$validate()
			if (!validated) {
				this.toast.error('Пожалуйста, заполните все поля');
				this.isLoading = false
				return
			}
			this.$refs.positions.updatePositions();
			this.$refs.repeatDates.updateRepeatDates();

			const formatedPositions = [];
			this.formData.positions.forEach((position) => {
				formatedPositions.push({...position});
			});
			for (let i = 0; i < formatedPositions.length; i++) {
				if(this.type === 'CO') {
					formatedPositions[i].startPrice = null
				} else if(typeof formatedPositions[i].startPrice === 'string') {
					formatedPositions[i].startPrice = formatedPositions[i].startPrice?.replace(/ /g, '');
				}
				formatedPositions[i].lotSize = formatedPositions[i].lotSize?.replace(/ /g, '');
				if(formatedPositions[i].supplyTimeFrom[0] !== '') {
					formatedPositions[i].supplyTimeFrom = this.getLocaleDateAndTime(formatedPositions[i].supplyTimeFrom[0],false)
				}
				if(formatedPositions[i].supplyTimeTo[0] !== '') {
					formatedPositions[i].supplyTimeTo = this.getLocaleDateAndTime(formatedPositions[i].supplyTimeTo[0], false)
				}
			}

			const body = objectToFormData({
				id: this.tenderId,
				interval: this.formData.interval,
				addTime: this.formData.addTime,
				priceStep: this.formData.priceStep.replace(/ /g,''),
				distrCenter: this.formData.distrCenter,
				deliveries: this.formData.deliveries,
				deliveryDestinations: this.formData.deliveryDestinations,
				shopGroups: this.formData.shopGroups,
				positions: formatedPositions,
				documents: this.formData.documents,
				description: this.formData.description,
				weekNumber: this.repeatValue === 'weekNumber' ? this.formData.dates.period : null,
				dayOfWeek: this.repeatValue === 'weekNumber' ? String(this.formData.dates.days) : null,
				monthNumber: this.repeatValue === 'monthNumber' ? this.formData.dates.period : null,
				dayOfMonth: this.repeatValue === 'monthNumber' ?  String(this.formData.dates.days) : null,
			})

			let response = await Fetch(this.tenderId ? 'tenders/schedules/update/' : 'tenders/schedules/add/', {
				method: 'POST',
				body
			})

			if(response.success) {
				this.toast.success(this.tenderId ? `График тендера успешно изменен` : `График тендера успешно добавлен`);
				this.tenderId = response.data
				window.location.href = '/personal/schedules/'
			} else {
				this.toast.error(response.message);
			}
			this.isLoading = false
		},

        async loadTenderInfo(id = this.tender.id) {
			this.isLoading = true
			const res = await this.requestSchedulesItem(id);
			if (res.success) {
				this.tender = res.data;
				this.fillFormData()
			}
		},

		fillFormData() {
			this.formData.addTime = this.tender.addTime
			this.tenderId = this.tender.id
			this.auctionStart = [moment(this.tender.auctionStart, "DD.MM.YYYY HH:mm").toDate()]
			this.auctionEnd = [moment(this.tender.auctionEnd, "DD.MM.YYYY HH:mm").toDate()]
			this.formData.priceStep = `${this.tender.priceStep || ''}`
			this.formData.description  = this.tender.description
			this.formData.documents  = this.tender.documents
			this.formData.interval = this.tender.interval
			this.formData.deliveries = this.fillSelect(this.tender.deliveries)

			if(this.tender.dayOfWeek) {
				this.repeatValue = 'weekNumber'
			} else {
				this.repeatValue = 'monthNumber'
			}
				
			this.auctionDates = [];
			this.tender.auctionDates.forEach(dates => {
				this.auctionDates.push({...dates, key: this.auctionDatesKey++});
			})

			setTimeout(() => this.formData.deliveryDestinations = this.fillSelect(this.tender.deliveryDestinations), 100)

			setTimeout(() => {
				this.formData.shopGroups = this.fillSelect(this.tender.shopGroups)
				this.formData.distrCenter = this.tender.distrCenter?.id
				this.$refs.positions.fillPositions(this.tender.positions);
				this.$refs.repeatDates.fillDates({days: this.tender.dayOfMonth || this.tender.dayOfWeek, period: this.tender.weekNumber || this.tender.monthNumber})
			}, 300)




			this.isLoading = false
		},

		fillSelect(array) {
			const selectedArray = []
			array?.forEach(item => selectedArray.push(item.id))
			return selectedArray
		},

		fillDateAuction() {
			this.auctionDates = [{
				key: this.auctionDatesKey++,
				auctionStart: [''],
				auctionEnd: [''],
			}];
		},

        ...mapActions({
            requestSchedulesItem: 'schedules/requestSchedulesItem',
		}),
	},
	validations() {
		return {
			repeatValue: {
				required: withMessage("Поле обязательно для заполнения", required),
			}
		}
	},
}
</script>


<style lang="sass">
.tender-form
	&.tender-form--disabled
		.table-card
			.table-card__btns, .copy, .delete
				display: none
			.default-input
				pointer-events: none
		.form
			.default-input
				pointer-events: none
		.default-checkbox
			pointer-events: none
</style>
